import { createRouter, createWebHistory } from 'vue-router'
import MapView from '@/views/navbar/MapView.vue';
import ChartsView from '@/views/map/ChartsView.vue';
import FlouView from '@/views/navbar/FlouView.vue';
import store from '../store';

// VUE_APP_MODE=local strips out auth pages (login/register/profile) at build
// time. process.env.VUE_APP_MODE is replaced by webpack's DefinePlugin with a
// string literal, so the dynamic import() calls below are unreachable in local
// builds and tree-shaken out of the bundle.
const isLocalMode = process.env.VUE_APP_MODE === 'local';

const authRoutes = isLocalMode ? [] : [
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "auth" */ '@/components/SignIn.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "auth" */ '@/components/SignIn.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/navbar/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/navbar/AdminView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
];

const routes = [
  {
    path: '/',
    redirect: '/map',
  },
  {
    path: '/map',
    name: 'map',
    component: MapView,
    meta: { requiresAuth: !isLocalMode },
  },
  {
    path: '/charts',
    name: 'charts',
    component: ChartsView,
    meta: { requiresAuth: !isLocalMode },
  },
  {
    path: '/fluo',
    name: 'fluo',
    component: FlouView,
    meta: { requiresAuth: !isLocalMode },
  },
  {
    path: '/profiling',
    name: 'profiling',
    component: MapView,
    meta: { requiresAuth: !isLocalMode },
  },
  ...authRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (isLocalMode) {
    next();
    return;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next('/login');
      return;
    }
    // UI-guard only; the backend enforces role on every /api/admin/* call.
    if (to.matched.some((record) => record.meta.requiresAdmin) && !store.getters.isAdmin) {
      next('/map');
      return;
    }
    next();
  } else {
    next();
  }
});

export default router
